export const adminbroker = [
    {
        id: 3457,
        name: "Gbenga Akinnukawe",
        email: "akinu@gmail.com",
        phoneNumber: "08098767898",
        gender:"Male",
        address: "Wuse zone 2, Abuja",
        tbcName: "admin-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        id: 7897,
        name: "Nneoma Raymond",
        email: "nenne@gmail.com",
        phoneNumber: "08098767898",
        gender:"Female",
        address: "Wuse zone 2, Abuja",
        tbcName: "admin-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        id: 5587,
        name: "Chukwuebuka Victor",
        email: "ebus@gmail.com",
        phoneNumber: "08098767898",
        gender:"Male",
        address: "Wuse zone 2, Abuja",
        tbcName: "admin-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        id: 7587,
        name: "Cynthia Nwankwo",
        email: "nwacynti@gmail.com",
        phoneNumber: "08098767898",
        gender:"Female",
        address: "Wuse zone 2, Abuja",
        tbcName: "admin-general-tbody",
        tbcIcon: "styletableicon"
     }
]